const fontFamiliy = '"Noto Sans", "Noto Sans Thai";';

export { fontFamiliy };
